import { createContext, useContext, type PropsWithChildren } from "react";
import type { MembershipApi } from "./api";
const Context = createContext<MembershipApi | null>(null);
export function MembershipProvider({
  api,
  children,
}: PropsWithChildren<{ api: MembershipApi }>) {
  return <Context.Provider value={api}>{children}</Context.Provider>;
}
export function useMembershipApi() {
  const api = useContext(Context);
  if (!api) throw new Error("MembershipProvider is required");
  return api;
}
export function useOptionalMembershipApi() {
  return useContext(Context);
}
